import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: function () {
      return import('../views/About.vue')
    }
  },
  {
    path: '/pricing',
    name: 'Subscription',
    component: function () {
      return import('../views/SubscriptionPage.vue')
    }
  },
  {
    path: '/sg/pricing',
    name: 'Singapore Subscriptoin',
    component: function () {
      return import('../views/SubscriptionPage.vue')
    }
  },
  {
    path: '/subscription-payment',
    name: 'SubscriptionPayment',
    component: function () {
      return import('../views/SubscriptionPaymentPage.vue')
    },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') === null) {
        next('/login')
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: function () {
      return import('../views/LoginPage.vue')
    },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') !== null) {
        // next(false)
        next('/pricing')
      } else {
        next()
      }
    }
  },
  {
    path: '/registration',
    name: 'Registration',
    component: function () {
      return import('../views/RegistrationPage.vue')
    },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') !== null) {
        // next(false)
        next('/pricing')
      } else {
        next()
      }
    }
  },
  {
    path: '/billing',
    name: 'Billing',
    component: function () {
      return import('../views/BillingPage.vue')
    },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('token') === null) {
        next('/login')
      } else {
        next()
      }
    }
  },
  {
    path: '/:username',
    name: 'Merchant',
    component: function () {
      return import('../views/Merchant.vue')
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
